import React, { useState, useEffect } from "react";
import NewModal from "../../Utils/Visuales/NewModal";
import { Grid } from "@mui/material";
import styles from "./styles.module.css";
import { useSnackbar } from "notistack";
import moment from "moment";
import { postRequest } from "../../Utils/Funciones/requester";
import Select from "react-select";

const statusOptions = [
  { value: "activo", label: "activo" },
  { value: "inactivo", label: "inactivo" },
];

const EditarConceptosDePagoParaGruposCerrados = ({
  open,
  close,
  userName,
  info,
  allInfo,
  id,
  getDataTable,
  options,
  campusUser2,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [newData, setNewData] = useState({});

  useEffect(() => {
    setNewData({
      campus: options?.campus?.find(
        (campus) => campus?.clave === info?.campus?.split("-")[0]
      ),
      escuela: options?.escuelas?.find(
        (escuela) =>
          parseInt(escuela?.value) === parseInt(info?.escuela?.split("-")[0])
      ),
      concepto: options?.conceptos?.find(
        (concepto) =>
          parseInt(concepto?.clave) === parseInt(info?.concepto?.split("-")[0])
      ),
      estatus: statusOptions?.find((status) => status.value === info?.estatus),
    });
  }, [info, options]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        id,
        data: allInfo.map((element) => {
          if (element.id === info.id) {
            return {
              ...element,
              modificado: moment().format("YYYY-MM-DD hh:mm:ss"),
              modificado_por: userName,
              campus: `${newData?.campus?.clave}-${newData?.campus?.nombre}`,
              escuela: `${newData?.escuela?.value}-${newData?.escuela?.nombre}`,
              concepto: `${newData?.concepto?.clave}-${newData?.concepto?.nombre}`,
              estatus: newData.estatus.value,
            };
          }
          return element;
        }),
      };
      const response = await postRequest("/parametro_reglas", payload);
      if (response.s === "OK") {
        enqueueSnackbar(response.m, {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        });
        getDataTable(id);
        handleClose();
      } else {
        enqueueSnackbar(response.m, {
          variant: "error",
          autoHideDuration: null,
          anchorOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChangeEstatus = (event) =>
    setNewData((prev) => ({ ...prev, estatus: event }));

  const handleClose = () => {
    setNewData({});
    close((prev) => ({ ...prev, param70: false }));
  };

  return (
    <NewModal
      title={`Configuración Pagos Extraordinarios a Grupos Cerrados`}
      open={open}
      handleClose={handleClose}
      maxWidth={900}
      height={200}
      loading={loading}
      overflowY={"unset"}
      handleSubmit={handleSubmit}
    >
      <div style={{ padding: "25px" }}>
        <Grid
          container
          spacing={1}
          style={{
            marginBottom: "30px",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Campus:</label>
          </Grid>
          <Grid item xs={8}>
            <input
              className={styles.modalInput}
              value={newData?.campus?.label}
              disabled
            />
          </Grid>
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Escuela:</label>
          </Grid>
          <Grid item xs={8}>
            <input
              className={styles.modalInput}
              value={newData?.escuela?.label}
              disabled
            />
          </Grid>
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Concepto:</label>
          </Grid>
          <Grid item xs={8}>
            <input
              className={styles.modalInput}
              value={newData?.concepto?.label}
              disabled
            />
          </Grid>
          <Grid item xs={3}>
            <label className={styles.inputLabel}>Estatus:</label>
          </Grid>
          <Grid item xs={8}>
            <Select
              classNamePrefix="select-modal"
              options={statusOptions}
              styles={{
                container: (styles) => ({ ...styles, zIndex: 16 }),
                singleValue: (styles) => ({ ...styles, textAlign: "center" }),
              }}
              onChange={handleChangeEstatus}
              value={newData?.estatus}
            />
          </Grid>
        </Grid>
      </div>
    </NewModal>
  );
};

export default EditarConceptosDePagoParaGruposCerrados;
